
import React from 'react'
import styled from 'styled-components';

import HTML_LOGO from '../assets/HTML5_badge.png';
import CSS_LOGO from '../assets/css3_logo.png';
import JS_LOGO from '../assets/js.png';
import REACT_LOGO from '../assets/react_logo.png';
import REDUX_LOGO from '../assets/redux_logo.png';
import NODE_LOGO from '../assets/Node-JS.png';
import MONGODB_LOGO from '../assets/mongoDb-logo.png';
import VERCEL_LOGO from '../assets/vercel_logo.png';
import POSTMAN_LOGO from '../assets/postman.png';
import NETLIFY_LOGO from '../assets/netlify-logo-transparent.png';
import GIT_LOGO from '../assets/git-logo-transparent.png';
import DSA from '../assets/dsa_img.png';
import EXPRESS from '../assets/express.png';


import { BOX, CONTAINER } from '../about/About'

export const Skills = () => {
  return (
    <CONTAINER id='skills'>
      <BOX>
      <p>What Skills I Have</p>
      <h2>Tech Stack</h2>

      <SKILLS_CONTAINER>
        <SKILLS_CONTENT>
          <SKILLS_LIST>
            <SKILL_CARD>
              <SKILL_ICON>
                <img src={HTML_LOGO} alt="" />
              </SKILL_ICON>
              <SKILLS_CARD_DETAILS>
                <h4>HTML</h4>
                {/* <small>skill level</small> */}
              </SKILLS_CARD_DETAILS>
            </SKILL_CARD>

            <SKILL_CARD>
              <SKILL_ICON>
                <img src={CSS_LOGO} alt="" />
              </SKILL_ICON>
              <SKILLS_CARD_DETAILS>
                <h4>CSS</h4>
                {/* <small>skill level</small> */}
              </SKILLS_CARD_DETAILS>
            </SKILL_CARD>

            <SKILL_CARD>
              <SKILL_ICON>
                <img src={JS_LOGO} alt="" />
              </SKILL_ICON>
              <SKILLS_CARD_DETAILS>
                <h4>Java script</h4>
                {/* <small>skill level</small> */}
              </SKILLS_CARD_DETAILS>
            </SKILL_CARD>

            <SKILL_CARD>
              <SKILL_ICON>
                <img src={REACT_LOGO} alt="" />
              </SKILL_ICON>
              <SKILLS_CARD_DETAILS>
                <h4>React</h4>
                {/* <small>skill level</small> */}
              </SKILLS_CARD_DETAILS>
            </SKILL_CARD>

            <SKILL_CARD>
              <SKILL_ICON>
                <img src={REDUX_LOGO} alt="" />
              </SKILL_ICON>
              <SKILLS_CARD_DETAILS>
                <h4>Redux</h4>
                {/* <small>skill level</small> */}
              </SKILLS_CARD_DETAILS>
            </SKILL_CARD>

            <SKILL_CARD>
              <SKILL_ICON>
                <img src={DSA} alt="" />
              </SKILL_ICON>
              <SKILLS_CARD_DETAILS>
                <h4>DSA</h4>
                {/* <small>skill level</small> */}
              </SKILLS_CARD_DETAILS>
            </SKILL_CARD>

            <SKILL_CARD>
              <SKILL_ICON>
                <img src={EXPRESS} alt="" />
              </SKILL_ICON>
              <SKILLS_CARD_DETAILS>
                <h4>Express Js</h4>
                {/* <small>skill level</small> */}
              </SKILLS_CARD_DETAILS>
            </SKILL_CARD>

            <SKILL_CARD>
              <SKILL_ICON>
                <img src={NODE_LOGO} alt="" />
              </SKILL_ICON>
              <SKILLS_CARD_DETAILS>
                <h4>NodeJS</h4>
                {/* <small>skill level</small> */}
              </SKILLS_CARD_DETAILS>
            </SKILL_CARD>

            <SKILL_CARD>
              <SKILL_ICON>
                <img src={MONGODB_LOGO} alt="" />
              </SKILL_ICON>
              <SKILLS_CARD_DETAILS>
                <h4>MongoDB</h4>
                {/* <small>skill level</small> */}
              </SKILLS_CARD_DETAILS>
            </SKILL_CARD>

            {/* <SKILL_CARD>
              <SKILL_ICON>
                <img src={GIT_LOGO} alt="" />
              </SKILL_ICON>
              <SKILLS_CARD_DETAILS>
                <h4>Git</h4>
                <small>skill level</small>
                
              </SKILLS_CARD_DETAILS>
            </SKILL_CARD>

            <SKILL_CARD>
              <SKILL_ICON>
                <img src={NETLIFY_LOGO}alt="" />
              </SKILL_ICON>
              <SKILLS_CARD_DETAILS>
                <h4>Netlify</h4>
                <small>skill level</small>
              </SKILLS_CARD_DETAILS>
            </SKILL_CARD> */}
            
            {/* <SKILL_CARD>
              <SKILL_ICON>
                <img src={VERCEL_LOGO} alt="" />
              </SKILL_ICON>
              <SKILLS_CARD_DETAILS>
                <h4>Vercel</h4>
                <small>skill level</small>
              </SKILLS_CARD_DETAILS>
            </SKILL_CARD> */}
            
          </SKILLS_LIST>
        </SKILLS_CONTENT>
      </SKILLS_CONTAINER>


     <br />
     <br />
      <p>What Tools, I use</p>
      <h2>Tool Stack</h2>

      <SKILLS_CONTAINER>
        <SKILLS_CONTENT>
          <SKILLS_LIST>
            
            <SKILL_CARD>
              <SKILL_ICON>
                <img src={GIT_LOGO} alt="" />
              </SKILL_ICON>
              <SKILLS_CARD_DETAILS>
                <h4>Git</h4>
                {/* <small>skill level</small> */}
                
              </SKILLS_CARD_DETAILS>
            </SKILL_CARD>

            <SKILL_CARD>
              <SKILL_ICON>
                <img src={NETLIFY_LOGO}alt="" />
              </SKILL_ICON>
              <SKILLS_CARD_DETAILS>
                <h4>Netlify</h4>
                {/* <small>skill level</small> */}
              </SKILLS_CARD_DETAILS>
            </SKILL_CARD>
            
            <SKILL_CARD>
              <SKILL_ICON>
                <img src={VERCEL_LOGO} alt="" />
              </SKILL_ICON>
              <SKILLS_CARD_DETAILS>
                <h4>Vercel</h4>
                {/* <small>skill level</small> */}
              </SKILLS_CARD_DETAILS>
            </SKILL_CARD>
            <SKILL_CARD>
              <SKILL_ICON>
                <img src={POSTMAN_LOGO} alt="" />
              </SKILL_ICON>
              <SKILLS_CARD_DETAILS>
                <h4>Postman</h4>
                {/* <small>skill level</small> */}
              </SKILLS_CARD_DETAILS>
            </SKILL_CARD>
            
          </SKILLS_LIST>
        </SKILLS_CONTENT>
      </SKILLS_CONTAINER>
      </BOX>

    
    </CONTAINER>
  )
}


const SKILLS_CONTAINER = styled.div`
 
`
const SKILLS_CONTENT = styled.div`
 width: 80%;
 margin: auto;

 @media screen and (min-width: 450px) and (max-width: 767px){
  width: 90%;
 }
 @media screen and (min-width: 300px) and (max-width: 449px){
  width: 100%;
 }
`
// minmax(300px, max-content)
// repeat(auto-fill, 300px);
const SKILLS_LIST = styled.div`
 display: grid;
 grid-template-columns: repeat(4, 4fr);
 
 justify-content: center;
 gap: 3rem;
 width: 95%;
 
 @media screen and (min-width: 768px) and (max-width: 1024px){
  grid-template-columns: repeat(4, 1fr);
  justify-content: center;
 }

 @media screen and (min-width: 450px) and (max-width: 767px){
  width: 100%;
  grid-template-columns: repeat(3, 1fr);
  justify-content: center;
  gap: 2rem 0;
 }
 @media screen and (min-width: 300px) and (max-width: 449px){
  width: 100%;
  grid-template-columns: repeat(2, 1fr);
  justify-content: center;
  gap: 2rem 2rem;
 }
`
const SKILL_CARD = styled.div`
 display:flex;
 flex-direction: column;
 width: 75%;
 margin: auto;
 padding: 1rem;
 border: 2px solid transparent;
 border-radius: 0.6rem;
 align-items: center;
 justify-content: center;
 box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
 transition: 0.6s;
 &:hover{
  z-index: 2;
  scale: 1.08;
  box-shadow: skyblue 0px 2px 10px;
 }
 
 @media screen and (min-width: 450px) and (max-width: 767px){
  width: 70%;
  margin: auto;
  padding: 1rem 0.5rem;
}
@media screen and (min-width: 300px) and (max-width: 449px){
  width: 70%;
 }
`
const SKILL_ICON = styled.div`
  border: 1px solid transparent;
  width: 5rem;
  height: 5rem;
  margin:auto;
  
 img{
  width: 100%;
  height: 100%;
  @media screen and (min-width: 768px) and (max-width: 1024px){
    width: 60%;
    height: 60%;
   }
  @media screen and (min-width: 300px) and (max-width: 767px){
    width: 50%;
    height: 50%;
  }
 }
`
const SKILLS_CARD_DETAILS = styled.div`
line-height: 1rem;
   h4{
    margin-top: 0.5rem;
    font-weight: bold;
    @media screen and (min-width: 300px) and (max-width: 767px){
      margin-top: -0.25rem;
    }
   }
   small{
    color: grey;
   }
   @media screen and (min-width: 768px) and (max-width: 1024px){
    margin-top: -1.5rem;
   }
  @media screen and (min-width: 300px) and (max-width: 767px){
    margin-top: -1rem;
  }
  
`
